import React, { useState, useRef } from "react";
import { useAddNewHelperMutation, useGetWardsQuery } from "./wardSlice";
const AddHelper = () => {
    const {
        data: wards,
        isSuccess,
        isError,
        error
    } = useGetWardsQuery('getWards');
    const [addhelper, setAddhelper] = useState({ name: "", number: "", h_ward_id: "" });
    const refClose = useRef(null);

    const [addNewHelper, { isLoading }] = useAddNewHelperMutation();

    const handleChange = (e) => setAddhelper({ ...addhelper, [e.target.name]: e.target.value });

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            await addNewHelper({ name: addhelper.name, number: addhelper.number, h_ward_id: addhelper.h_ward_id }).unwrap()
            setAddhelper({ name: "", number: "", h_ward_id: "" })
            refClose.current.click()
        }
        catch (e) {
            console.log(e)
        }
    }
    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add New Helper</button>
            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add Helper</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="community_name" className="form-label font-weight-bold">
                                    Header Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="name"
                                    value={addhelper.name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="community_name" className="form-label font-weight-bold">
                                    Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="number"
                                    value={addhelper.number}
                                    onChange={handleChange}
                                    placeholder="Number"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="district_id" className="form-label font-weight-bold">
                                    District Name
                                </label>
                                <select value={addhelper.h_ward_id} onChange={handleChange} className="form-select" id="district_id" name="h_ward_id" required>
                                    <option value="" defaultValue>
                                        Select Ward
                                    </option>
                                    {/* <option value={"4cd2"}>50</option>
                                    <option value={"a0f5"}>93</option> */}
                                    {wards?.ids?.map((e) => {
                                        return <option value={wards?.entities[e]?.ward_id}>{wards?.entities[e]?.ward_number}</option>
                                    })}
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                    disabled={!(addhelper.name && addhelper.number && addhelper.h_ward_id)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddHelper